import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { email as EmailValidator } from 'web-core/src/utils/validate';
import Translate, { TranslateProps } from 'client/components/translate';
import { postEmailSubscription } from 'client/actions/subscribe';
import InputGroup from 'client/components/form/inputGroup';

const mapStateToProps = (state, ownProps) => {
  const stateLists = _.get(state, 'subscribe.lists', []);

  return {
    isSubscribed: _.every(ownProps.lists, listItem => stateLists.indexOf(listItem) > -1),
  };
};

const propTypes = {
  label: TranslateProps,
  error: TranslateProps,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  buttonStyle: PropTypes.object,
  buttonLabel: TranslateProps,
  submitHandler: PropTypes.func,
  lists: PropTypes.arrayOf(PropTypes.string).isRequired,
  postEmailSubscription: PropTypes.func.isRequired,
  isSubscribed: PropTypes.bool.isRequired,
  subscribedLabel: TranslateProps.isRequired,
  subscribeSuccessStyle: PropTypes.object,
  subscribeSuccessIcon: PropTypes.node,
  id: PropTypes.string,
};

const defaultProps = {
  label: { path: 'common.label.email' },
  submitHandler: () => {},
  className: '',
  buttonClassName: '',
  buttonStyle: {},
  buttonLabel: null,
  error: null,
  subscribeSuccessStyle: null,
  subscribeSuccessIcon: null,
  id: 'email-input',
};

class EmailSubscriptionContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      error: null,
      success: false,
    };
  }

  handleChange = (event) => {
    const { value } = event.target;
    this.setState({ value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (EmailValidator.test(this.state.value)) {
      const params = {
        email: this.state.value,
        lists: this.props.lists,
      };

      this.props.postEmailSubscription({ params }).then(() => {
        this.setState({ success: true });
        this.props.submitHandler();
      });
    } else {
      this.setState({ error: { path: 'common.error.invalidEmail' } });
    }
  };

  render() {
    const {
      isSubscribed,
      subscribedLabel,
      subscribeSuccessIcon,
      subscribeSuccessStyle,
    } = this.props;

    if (isSubscribed || this.state.success) {
      const translateProps = {
        ...subscribedLabel,
        using: {
          ...subscribedLabel.using,
          email: this.state.value,
        },
      };

      return (
        <div style={subscribeSuccessStyle}>
          {subscribeSuccessIcon}
          <Translate {...translateProps} />
        </div>
      );
    }

    return (
      <form onSubmit={this.handleSubmit}>
        <InputGroup
          id={this.props.id}
          label={this.props.label}
          value={this.state.value}
          containerClassName={this.props.className}
          onChange={this.handleChange}
          error={this.props.error || this.state.error}
          type="email">
          <button
            style={this.props.buttonStyle}
            className={this.props.buttonClassName}
            onClick={this.handleSubmit}>
            {this.props.buttonLabel ? (
              <span style={{ padding: '0 1rem' }}>
                <Translate {...this.props.buttonLabel} />
              </span>
            ) : null}
          </button>
        </InputGroup>
      </form>
    );
  }
}
EmailSubscriptionContainer.propTypes = propTypes;
EmailSubscriptionContainer.defaultProps = defaultProps;

export default connect(mapStateToProps, {
  postEmailSubscription,
})(EmailSubscriptionContainer);
